import { CssBaseline, GlobalStyles, Theme, ThemeProvider } from '@mui/material';
import type { GlobalStylesProps as StyledGlobalStylesProps } from '@mui/system/GlobalStyles/GlobalStyles';
import { Fragment, JSX } from 'react';

import { useViewModel } from '@vp/common/ui/hook/useViewModel';
import { AppMenu } from '@vp/menu/ui/AppMenu';
import { AppNotificationOutlet } from '@vp/notification/AppNotificationOutlet';
import { scrollbarStyles } from '@vp/theme/scrollbarStyles';

import { AppRouter } from './AppRouter';
import { AppViewModel } from './AppViewModel';
import { theme } from './theme/theme';

export const App = (): JSX.Element => {
  const viewModel = useViewModel(AppViewModel);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={scrollbarStyles as StyledGlobalStylesProps<Theme>['styles']} />
      {viewModel.initialized.value && (
        <Fragment>
          <AppMenu />
          <AppRouter />
          <AppNotificationOutlet />
        </Fragment>
      )}
    </ThemeProvider>
  );
};
